import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid formgrid grid"
}
const _hoisted_2 = { class: "field col-12 lg:col-2 text-right pb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_4 = { class: "flex justify-content-between flex-wrap" }
const _hoisted_5 = { class: "flex-1 flex align-items-center justify-content-start" }
const _hoisted_6 = { class: "flex-1 flex align-items-center justify-content-center" }
const _hoisted_7 = { class: "flex-1 flex align-items-center justify-content-end" }
const _hoisted_8 = { class: "p-input-icon-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_10 = { class: "confirmation-content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle mr-3",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_KoruSplitButton = _resolveComponent("KoruSplitButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_KoruActionButton = _resolveComponent("KoruActionButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Filters = _resolveComponent("Filters")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      class: _normalizeClass(`p-datatable-${_ctx.moduleRef.suffix} ${_ctx.additionalClass}`),
      currentPageReportTemplate: _ctx.t('gen.pageResults').replaceAll('[[', '{').replaceAll(']]', '}'),
      dataKey: "id",
      filterDisplay: "menu",
      filters: _ctx.filtersRef,
      "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtersRef) = $event)),
      globalFilterFields: _ctx.moduleRef.searchFields,
      paginator: true,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      responsiveLayout: "scroll",
      rows: 10,
      rowsPerPageOptions: [10, 25, 50, 100],
      rowClass: _ctx.rowClass,
      showGridlines: "",
      sortField: _ctx.moduleRef.sortField,
      sortOrder: _ctx.moduleRef.sortOrder,
      stateStorage: "session",
      stateKey: `datatable-${_ctx.moduleRef.suffix}-${_ctx.config.app.version.replace(/\./g, '-')}`,
      stripedRows: "",
      value: _ctx.moduleRef.documents.value
    }, {
      header: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          (_ctx.moduleRef.onLoadWithFiltersAction !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "filtersRow"),
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_Button, {
                    label: _ctx.t('buttons.load'),
                    icon: "pi pi-filter",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadWithFilters()))
                  }, null, 8, ["label"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "beforeCreateButton"),
              _renderSlot(_ctx.$slots, "createButton", {}, () => [
                (
                  _ctx.moduleRef.canCreate &&
                  _ctx.user.canCreate(_ctx.requiredModule) &&
                  (_ctx.moduleRef.createCommands === undefined || _ctx.moduleRef.createCommands.length === 0)
                )
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "mr-4",
                      icon: "pi pi-plus",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createAction()))
                    }, null, 512)), [
                      [
                        _directive_tooltip,
                        _ctx.t('buttons.create'),
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                (
                  _ctx.moduleRef.canCreate &&
                  _ctx.user.canCreate(_ctx.requiredModule) &&
                  _ctx.moduleRef.createCommands !== undefined &&
                  _ctx.moduleRef.createCommands.length > 0
                )
                  ? _withDirectives((_openBlock(), _createBlock(_component_KoruSplitButton, {
                      key: 1,
                      class: "mr-4",
                      icon: "pi pi-plus",
                      defaultAction: _ctx.createAction,
                      model: _ctx.moduleRef.createCommands
                    }, null, 8, ["defaultAction", "model"])), [
                      [
                        _directive_tooltip,
                        _ctx.t('buttons.create'),
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ]),
              (_ctx.moduleRef.filters.value.filter((f) => f.isToggable === true).length > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "mr-4",
                    icon: "pi pi-filter",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleFilterSelectors($event)))
                  }))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "additionalButtons")
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moduleRef.filters.value.filter((f) => f.isToggable === true), (filter) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: filter.name,
                  class: _normalizeClass({
                badge: true,
                'ml-2': true,
                'mr-2': true,
                'status-green': filter.browserFilter.value === null,
                'status-orange': filter.browserFilter.value === false,
              })
                }, _toDisplayString(filter.browserFilter.value === null ? filter.labelIncluded : filter.labelExcluded), 3))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "rightHeader", {}, () => [
                _createElementVNode("span", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_InputText, {
                    modelValue: (_ctx.filtersRef.global as DataTableFilterMetaData).value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (((_ctx.filtersRef.global as DataTableFilterMetaData).value) = $event)),
                    placeholder: _ctx.t('gen.search')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
      ]),
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "columns"),
        (
        _ctx.moduleRef.canView ||
        _ctx.moduleRef.canEdit ||
        _ctx.moduleRef.canDelete ||
        (_ctx.moduleRef.contextCommands !== undefined && _ctx.moduleRef.contextCommands.length > 0)
      )
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              headerStyle: "width: 10%",
              bodyClass: "text-center",
              header: _ctx.t('gen.actions')
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_KoruActionButton, {
                  model: _ctx.getContextCommands(data),
                  reference: data
                }, null, 8, ["model", "reference"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["class", "currentPageReportTemplate", "filters", "globalFilterFields", "rowClass", "sortField", "sortOrder", "stateKey", "value"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDeleteItemDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showDeleteItemDialog) = $event)),
      style: { width: '450px' },
      header: _ctx.t('gen.deleteTitle'),
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.t('gen.no'),
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteItemDialog = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: _ctx.t('gen.yes'),
          icon: "pi pi-check",
          class: "p-button-text",
          onClick: _ctx.deleteItemAction
        }, null, 8, ["label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.t("gen.deleteConfirm")) + " ", 1),
            (_ctx.moduleRef.deleteDescriptionField == undefined)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.t("gen.deleteObject")), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.DataHelpers.getObjectValueByNestedKey(_ctx.deleteItem, _ctx.moduleRef.deleteDescriptionField)), 1),
                  _createTextVNode(" ? ")
                ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    (_ctx.moduleRef.filters.value.length > 0)
      ? (_openBlock(), _createBlock(_component_Filters, {
          key: 0,
          browserModule: _ctx.moduleRef,
          "onUpdate:browserModule": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.moduleRef) = $event))
        }, null, 8, ["browserModule"]))
      : _createCommentVNode("", true)
  ], 64))
}